import Section from "./common/section";
import SectionTitle from "./common/section-title";

export default function FeatureTrial() {
  return (
    <Section id="feature-trial" bg="bg-primary" className="text-center px-4">
      <SectionTitle color="text-white">Feature Trial</SectionTitle>
      <div className="bg-white mt-8 shadow-lg rounded w-fit mx-auto">
        <div className="py-8 prose px-8 md:mx-auto text-left">
          <h2>
            ETHAN: A phase 2 study comparing different Endocrine THerapies for
            mAle breast canNcer
          </h2>
          <h4>Breaking it down:</h4>
          <p>
            How well does male breast cancer respond to pre-operative treatment
            with endocrine therapy and which one is the most effective?
          </p>
          <h4>Eligibility Criteria:</h4>
          <ol>
            <li>
              Are you man recently diagnosed with breast cancer (before surgery)
              and 18 years or older??
            </li>
            <li>
              Is your breast cancer Stage 1,2, or 3 and hormone-receptor
              positive and HER 2- negative?
            </li>
          </ol>
          <h4>Trial:</h4>
          <ul>
            <li>Open label, Randomized, Treatment trial.</li>
          </ul>
          <h4>Drugs used:</h4>
          <ul>
            <li>
              Tamoxifen (Brand name is Novadex), is currently the standard of
              care for men with breast cancer. It is classified as an oral
              Selective Estrogen Receptor Modulator (SERM) and blocks the
              estrogen receptors on cells.
            </li>
            <li>
              Anastrozole (Brand name is Arimidex), used to treat
              hormone-receptor positive breast cancer by lowering estrogen
              levels in the body. It is an oral nonsteroidal aromatase
              inhibitor.
            </li>
            <li>
              Degarelix (Brand name is Firmagon), used for gonadal suppression
              by lowering testosterone. It is administered by a subcutaneous
              injection under the skin.
            </li>
            <li>
              Abemaciclib (Brand name is Verzenio), an oral targeted therapy
              used to treat hormone positive and HER2- negative breast cancer.
              It is classified as a cyclin-dependent kinase (CDK) 4/6 inhibitor.
              It is currently prescribed for high-risk for reoccurrence,
              advanced or metastatic breast cancer. It works by blocking
              proteins on the cancer cells, to prevent the cell cycle and will
              inhibit growth and spread of the cancer cells.
            </li>
          </ul>
          <h4>Locations and Contacts:</h4>
          <p>
            7 locations through-out the United States, including Pittsburgh.
          </p>
          <ul>
            <li>
              <div>Carol Glock M.Ed</div>
              <div>Phone: 412-680-6496</div>
            </li>
            <li>
              <div>Cortney Montgomery BSN, RN, CCRP, CBCN</div>
              <div>Phone: 412-641-1840</div>
            </li>
          </ul>
        </div>
      </div>
    </Section>
  );
}
